import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveOrganizationState {
  activeOrganizationId: string | null;
  setActiveOrganization: (id: string | null) => void;
  _hasHydrated: boolean;
}

export const useActiveOrganization = create<ActiveOrganizationState>()(
  persist(
    (set) => ({
      activeOrganizationId: null,
      setActiveOrganization: (id: string | null) => set({ activeOrganizationId: id }),
      _hasHydrated: false,
    }),
    {
      name: 'active-organization',
      // Exclude _hasHydrated from being persisted to localStorage
      partialize: (state) => ({ activeOrganizationId: state.activeOrganizationId }),
    }
  )
);

// Subscribe to hydration finish and set the flag
useActiveOrganization.persist.onFinishHydration(() => {
  useActiveOrganization.setState({ _hasHydrated: true });
});
